exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-toast-container{position:fixed;z-index:5000;top:40%;left:0;right:0;display:flex;justify-content:center}.layout-toast-main{background:hsla(0,0%,7%,.7);text-align:center;border-radius:5px;color:#fff;padding:10px 15px}.layout-toast-text{min-width:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/layouts/PageLayout/PageLayout.css
// module id = 343
// module chunks = 5